import script from "./ArticlePollContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlePollContainer.vue?vue&type=script&setup=true&lang=js"

import "./ArticlePollContainer.vue?vue&type=style&index=0&id=0c8b9a15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c8b9a15"]])

export default __exports__